import { apis } from "config/urls";
import { deleteAPI, getAPI, postAPI, putAPI } from "utils/http";

export async function getOverviewLevel3({ productId, template = null, token }) {
  const payLoad = {
    op_code: "get_parametric_data",
    product_id: Number(productId),
    function_id: 2,
    offset: 0,
    count: 100,
    ...(template ? { template } : ""),
  };
  const res = await getAPI(apis.GWAPI, payLoad, token);
  return res.data;
}

export async function deleteTemplateRow({ token, id, productId }) {
  const res = await deleteAPI(
    apis.parametricAPI,
    { id: Number(id), product_id: Number(productId) },
    token
  );
  return res.data;
}

export async function updateTemplateRow({ token, formData }) {
  const res = await putAPI(apis.parametricAPI, formData, token);
  return res.data;
}

export async function addTemplateRow({ token, formData }) {
  const res = await postAPI(apis.parametricAPI, formData, token);
  return res.data;
}

export async function getTemplateList({ token, product_id }) {
  const res = await getAPI(apis.parametricAPI, { product_id }, token);
  return res.data;
}

export async function refreshTemplateList({ token }) {
  const res = await getAPI(apis.refreshParametricAPI, {}, token);
  return res.data;
}
